import { createFileRoute } from '@tanstack/react-router'
import { GetTheAppScreen } from '@/features/self-service/get-the-app-screen'

/**
 * Route shell. Definition only — the page lives in a feature.
 *
 * Deliberately a TOP-LEVEL route, a sibling of `/login`, and NOT a child of
 * `_authenticated`. That placement is what stops the redirect in
 * `_authenticated.tsx` from looping: the guard that sends a self-service-only
 * session here never runs for this path, so the page cannot bounce itself.
 * It also means the page needs no shell, which is what its audience should
 * see — this app has nothing else to offer them.
 *
 * There is no `beforeLoad`. `/login`'s guard is the reverse of this one and
 * bounces a signed-in visitor away; that would be wrong here, because every
 * visitor to this page arrives signed in.
 */
export const Route = createFileRoute('/get-the-app')({
  component: GetTheAppScreen,
})
